var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:['promotions__category', _vm.isSelected ? 'active' : 'disable']},[_c('button',{attrs:{"type":"button"},on:{"click":_vm.onClick}},[_vm._v(_vm._s(_vm.promotionsBrand.title || "Всі бренди"))])])
}
var staticRenderFns = []

export { render, staticRenderFns }